import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import {
  MatRippleModule,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatRadioModule } from '@angular/material/radio';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTimepickerModule} from '@angular/material/timepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';

import { EmailMaskPipe } from './pipe/email-mask-pipe';
import { MobileMaskPipe } from './pipe/mobile-mask-pipe';
import { TimezoneDatePipe } from './pipes/timezone-date.pipe';
import { DateOnlySafePipe } from './pipes/date-only-safe.pipe';
import { CategoryOptionLabelPipe } from './pipes/category-option-label.pipe';
import { SignupProfileEdit } from './components/signup-profile-edit/signup-profile-edit';
import { SubscriptionBanner } from './components/subscription-banner/subscription-banner';
import { Spinner } from './components/spinner/spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AvgRegPerWeek } from './components/avg-reg-per-week/avg-reg-per-week';
import { BarChart } from './components/bar-chart/bar-chart';
import { DonutChart } from './components/donut-chart/donut-chart';
import { GaugeChart } from './components/gauge-chart/gauge-chart';
import { PiaChart } from './components/pia-chart/pia-chart';
import { PaperBarChart } from './components/paper-bar-chart/paper-bar-chart';
import { PaperSubmissionAverageMonthly } from './components/paper-submission-average-monthly/paper-submission-average-monthly';
import { PerformanceService } from './service/performance-service';
import { ProfileImageUpload } from './components/profile-image-upload/profile-image-upload';
import { PhoneInput } from './components/phone-input/phone-input';
import { EmailGeneratePopup } from '../page/main/global-email-configuration/email-generate-popup/email-generate-popup';
import { EditorModule } from './editor/editor.module';
import { DigitalClock } from './components/digital-clock/digital-clock';


export function createMatPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.getRangeLabel = () => '';
  return intl;
}

@NgModule({
  declarations: [
    EmailMaskPipe,
    MobileMaskPipe,
    SignupProfileEdit,
    Spinner,
    AvgRegPerWeek,
    BarChart,
    DonutChart,
    GaugeChart,
    PiaChart,
    PaperSubmissionAverageMonthly,
    PaperBarChart,
    ProfileImageUpload,
    EmailGeneratePopup,
    PhoneInput,
    SubscriptionBanner,
    DigitalClock,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatTableModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatDividerModule,
    MatRippleModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonToggleModule,
    DragDropModule,
    CdkAccordionModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatRadioModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatTimepickerModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatCardModule,
    MatChipsModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTabsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-pulse' }),
    EditorModule,
    TimezoneDatePipe,
    DateOnlySafePipe,
    CategoryOptionLabelPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatTableModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatDividerModule,
    MatRippleModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonToggleModule,
    DragDropModule,
    CdkAccordionModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatRadioModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    MatTimepickerModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatCardModule,
    MatChipsModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTabsModule,
    NgxSpinnerModule,
    EmailMaskPipe,
    MobileMaskPipe,
    Spinner,
    AvgRegPerWeek,
    BarChart,
    DonutChart,
    GaugeChart,
    PiaChart,
    PaperSubmissionAverageMonthly,
    PaperBarChart,
    ProfileImageUpload,
    EmailGeneratePopup,
    PhoneInput,
    SubscriptionBanner,
    TimezoneDatePipe,
    DateOnlySafePipe,
    CategoryOptionLabelPipe,
    DigitalClock,
  ],
  providers: [
    provideNativeDateAdapter(),
    PerformanceService,
    { provide: MatPaginatorIntl, useFactory: createMatPaginatorIntl },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
